import { createContext, useState, useEffect } from "react";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    try {
      if (typeof window !== "undefined") {
        const raw = localStorage.getItem("poomalai_cart");
        if (raw) return JSON.parse(raw);
      }
    } catch (err) {
      console.debug("CartContext: failed to read cart from localStorage", err);
    }
    return [];
  });

  const addToCart = (product) => {
    console.debug("CartContext.addToCart called with:", product);
    // Use functional updates to avoid stale closures and ensure updates merge correctly
    setCart((prev) => {
      const found = prev.find((p) => p.id === product.id);
      if (found) {
        const updated = prev.map((p) => (p.id === product.id ? { ...p, qty: (p.qty || 0) + 1 } : p));
        console.debug("CartContext.addToCart -> updated cart (increment):", updated);
        return updated;
      }
      // attach selected options if provided, but don't mutate original product
      const next = [...prev, { ...product, qty: 1 }];
      console.debug("CartContext.addToCart -> added new item:", next);
      return next;
    });
  };

  const removeFromCart = (id) => {
    setCart((prev) => {
      const next = prev.filter((p) => p.id !== id);
      console.debug("CartContext.removeFromCart -> next cart:", next);
      return next;
    });
  };

  const clearCart = () => {
    setCart([]);
  };

  // persist cart to localStorage so a production full-reload retains items
  useEffect(() => {
    try {
      if (typeof window !== "undefined") {
        localStorage.setItem("poomalai_cart", JSON.stringify(cart));
      }
    } catch (err) {
      console.debug("CartContext: failed to write cart to localStorage", err);
    }
  }, [cart]);

  const total = cart.reduce((sum, p) => sum + (Number(p.starting_price ?? p.price ?? 0) * (p.qty || 0)), 0);

  return (
    <CartContext.Provider value={{ cart, addToCart, removeFromCart, clearCart, total }}>
      {children}
    </CartContext.Provider>
  );
};